import { CSS } from '@dnd-kit/utilities';
import { CiMenuBurger } from "react-icons/ci";
import { useSortable } from '@dnd-kit/sortable';


import { ItemProps } from '../../types/globalTypes';



export default function CategoryDND({ id, title }: ItemProps) {


    const { attributes, listeners, setNodeRef, transform, transition , isDragging} = useSortable({ id })


    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    }


 
  
   



    return (
        <>
            <div
                ref={setNodeRef}
                {...attributes}
                {...listeners}
                style={style}
                className='touch-none flex gap-1 rounded-xl px-3 py-2 border cursor-grab  transition-all  items-center '
              
            >
                <CiMenuBurger  className=''/>
                <h2 className="font-semibold ">{title}</h2>
            </div>

        </>
    )
}
